import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useWorkstations } from '@/hooks/v1';
import { toOptions } from '@/views/Bera/_components/Filter/utils';
import { useApplicationContext } from '@/context/v1/Application/context';
import { HierarchySelect } from '@/views/Bera/_components/Filter/Fields/HierarchySelect';

import type { BeraFilterFormFields } from '@/views/Bera/types';

const { useFormInstance, useWatch } = Form;

export function Workstation(): JSX.Element {
	const form = useFormInstance<BeraFilterFormFields>();
	const { organization } = useApplicationContext();

	const companyId = useWatch('company_id_filter', form);
	const lineId = useWatch('line_id', form);

	const {
		data: workstations,
		isLoading,
		isFetching,
		isError
	} = useWorkstations({
		organization_id: organization?.id,
		company_id: companyId,
		line_id: lineId
	});

	return (
		<Col xs={24}>
			<Form.Item name="workstation_id" label={I18n.get('Workstation')} labelCol={{ span: 24 }}>
				<HierarchySelect
					loading={isFetching}
					options={toOptions(workstations)}
					placeholder={I18n.get('Workstation')}
					disabled={isLoading || isFetching || isError || !lineId}
				/>
			</Form.Item>
		</Col>
	);
}
